export const SET_DETAILS_USERS = 'SET_DETAILS_USERS';
export const SET_PAGINATION_PAGE_USERS = 'SET_PAGINATION_PAGE_USERS';
export const SET_PAGINATION_SIZEPERPAGE_USERS = 'SET_PAGINATION_SIZEPERPAGE_USERS';
export const SET_DETAILS_ERROR_USERS = 'SET_DETAILS_ERROR_USERS';
export const SET_INVITE_ERROR_USERS = 'SET_INVITE_ERROR_USERS';
export const CLEAR_ERROR_USER = 'CLEAR_ERROR_USER';
